"use client";

import { FilterOptions } from "@/context/SearchContext";
import { SearchResult } from "@/types/journal";
import { Branding } from "@/types/branding";

export const BASE_API_URL =
  typeof window === "undefined"
    ? "http://localhost:3001/api"
    : process.env.NODE_ENV === "development"
      ? "http://localhost:3001/api"
      : process.env.NEXT_PUBLIC_API_URL;

export async function getBranding(slug: string) {
  const response = await fetch(`${BASE_API_URL}/custom/${slug}/branding`);
  if (response.status !== 200) {
    return null;
  }
  return response.json() as Promise<Branding | null>;
}

export async function getSearchResults(
  slug: string,
  searchTerm: string,
  filters: FilterOptions = {},
  skip?: number
) {
  const params = new URLSearchParams();
  params.set("term", searchTerm);
  params.set("account", slug);
  if (skip) {
    params.set("skip", skip.toString());
  }
  for (const [key, values] of Object.entries(filters)) {
    values.forEach((value: string) => {
      params.append(`${key}[]`, value);
    });
  }

  const response = await fetch(`${BASE_API_URL}/search?${params.toString()}`);
  return response.json() as Promise<SearchResult>;
}